import React from "react"
import { Row, Col, Label, Card, CardTitle, CardBody } from "reactstrap"
function MarketingOptIn() {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Marketing Opt In</CardTitle>

        <div className="row mb-4">
          <Col xs={6} sm={4} md={4} lg={6}>
            {/* <Label className="col-form-label">Can Bet Using</Label> */}
          </Col>
          <Col xs={6} sm={8} md={8} lg={6}>
            <Row>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="radio"
                  value=""
                  id="defaultCheck2"
                  defaultChecked
                  name="marketing_radio"
                />
                <label className="form-check-label" htmlFor="defaultCheck2">
                  Mobile
                </label>
              </div>{" "}
            </Row>
            <Row>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="radio"
                  value=""
                  id="defaultCheck2"
                  name="marketing_radio"
                />
                <label className="form-check-label" htmlFor="defaultCheck2">
                  Online
                </label>
              </div>{" "}
            </Row>
            <Row>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="radio"
                  value=""
                  id="defaultCheck2"
                  name="marketing_radio"
                />
                <label className="form-check-label" htmlFor="defaultCheck2">
                  SMS
                </label>
              </div>{" "}
            </Row>
            <Row>
              <div className="form-check form-check-end">
                <input
                  className="form-check-input"
                  type="radio"
                  value=""
                  id="defaultCheck2"
                  name="marketing_radio"
                />
                <label className="form-check-label" htmlFor="defaultCheck2">
                  Telegram
                </label>
              </div>{" "}
            </Row>
          </Col>
        </div>
      </CardBody>
    </Card>
  )
}

export default MarketingOptIn
